<div class="wrapper-my-content" (scroll)="onScroll()">
  <div class="wrapper-header-my-content">
    <span>{{'NEW_TEXT.my_content' | translate}}</span>
    <button (click)="openDropdown = true" class="custom-btn custom-btn--circle-primary">
      <img src="../../../assets/icons/outline/icon-plus.svg" alt="">
    </button>
    <div *ngIf="openDropdown" class="dropdown-content-add">
      <div class="item-content-dropdown" [routerLink]="[PAGES_AND_PATHS.createList.pagePath]">
        <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
        <span>{{'CREATE_NEW_LIST.create_new_list' | translate}}</span>
      </div>
      <div class="item-content-dropdown" [routerLink]="[PAGES_AND_PATHS.createPost.pagePath]">
        <img src="../../../assets/icons/outline/icon-posts.svg" alt="">
        <span>{{'NEW_TEXT.create_new_post' | translate}}</span>
      </div>
    </div>
  </div>
  <div class="wrapper-content-my-content">
    <div class="tabs-my-content">
      <div (click)="selectTab('lists')" class="tab-my-content" [ngClass]="{'active': tabSelected === 'lists'}">
        <span>{{'LISTS.my_lists' | translate}}</span>
      </div>
      <div (click)="selectTab('posts')" class="tab-my-content" [ngClass]="{'active': tabSelected === 'posts'}">
        <span>{{'NEW_TEXT.my_posts' | translate}}</span>
      </div>
      <div (click)="selectTab('listers')" class="tab-my-content" [ngClass]="{'active': tabSelected === 'listers'}">
        <span>{{'NEW_TEXT.my_listers' | translate}}</span>
      </div>
    </div>
    <div>
      <app-lists *ngIf="tabSelected === 'lists'"></app-lists>
      <app-posts *ngIf="tabSelected === 'posts'" [myPosts]="true" (postUrl)="postUrl = $event"(postToShare)="postToShare = $event"  ></app-posts>
      <app-listers *ngIf="tabSelected === 'listers'"></app-listers>
    </div>
  </div>
</div>
<tl-sharing-options-modal *ngIf="postToShare" [entityType]="ShareEntitiesEnums.post"
                          [entityId]="postToShare.id" [urlForShare]="postUrl"
                          (closeModal)="postToShare = null"></tl-sharing-options-modal>

